import { Flex, IconButton, Tooltip } from '@aloft/toolkit-sui';

import { VacantLandSales } from '../../../components/VacantLandSales/VacantLandSales.tsx';
import { featuresSelectors } from '../../../redux/features/selectors/featuresSelectors.ts';
import { selectCompSequence } from '../../../redux/features/selectors/orderSelectors.ts';
import { useAppSelector } from '../../../redux/hooks.ts';
import { Typography } from '../../../summary/components/Typography.tsx';
import { Tkv2SiteValueCharts } from '../Tkv2SiteValueCharts.tsx';
import { useSiteValueAdjuster } from '../utils/useSiteValueAdjuster.ts';

export const Tkv2SiteValue = ({ isPopout }: { isPopout: boolean }) => {
  const compSequence = useAppSelector(selectCompSequence);
  const shouldShowAdjuster = useAppSelector(featuresSelectors.selectShouldShowSiteValueAdjuster);
  const { adjust } = useSiteValueAdjuster();

  const handleAdjustEffectiveAge = () => {
    adjust();
  };

  return (
    <Flex flexDirection="column" gap="1rem">
      <Flex paddingTop="1rem" paddingLeft="2rem" justifyContent="space-between" alignItems="center">
        <Typography variant="h1">Site Analysis</Typography>
        <Flex paddingRight="2rem" gap="1rem">
          <IconButton
            ariaLabel="Knowledge Base"
            variant="tertiary"
            iconSize="lg"
            icon="information"
            onClick={() =>
              window.open(
                'https://www.loom.com/share/c7dbe08431dc4b27b93f185028ccad3f?sid=c5860b3c-aa0b-4eb3-aa32-a56a59dc102d',
                '_blank',
                'noopener,noreferrer',
              )
            }
          />
          {shouldShowAdjuster && (
            <Tooltip
              label="Adjust with Power curve: makes site size and site value proportional across properties"
              placement="left"
              hasArrow
            >
              <IconButton
                icon="chart-mixed"
                size="md"
                variant="primary"
                ariaLabel="Adjust effective age using Power curve"
                onClick={handleAdjustEffectiveAge}
                disabled={compSequence.length <= 1}
              />
            </Tooltip>
          )}
        </Flex>
      </Flex>
      <Tkv2SiteValueCharts isPopout={isPopout} />
      <VacantLandSales isPopout={isPopout} />
    </Flex>
  );
};
